const blogInfo = [
    {
        id: 1,
        image: 'https://miro.medium.com/max/750/1*w5BcC5h7lZhWUOlijg8qxw.png',
        link: 'https://abuhorain2016.medium.com/react-core-concept-c62664b6edee'
    },
    {
        id: 2,
        image: 'https://miro.medium.com/max/1050/1*RUp6eCoBoXOzjfUM-1kbpQ.jpeg',
        link: 'https://abuhorain2016.medium.com/javascript-some-interview-question-18e4aebb4592'
    },
    {
        id: 3,
        image: 'https://miro.medium.com/max/960/1*kCD_6R3UkMHkpS_YgFoU9w.jpeg',
        link: 'https://abuhorain2016.medium.com/es6-some-important-topic-d3500d61290c'
    },
    {
        id: 4,
        image: 'https://miro.medium.com/max/1050/1*Biy_Ovmmis_HfYM0erTGcg.jpeg',
        link: 'https://abuhorain2016.medium.com/javascript-some-functionality-d90a4428c741'
    }
];

export default blogInfo;